import React, { useCallback, useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { UiButton } from '@shared/ui';
import { CustomModal } from '@shared/ui/CustomModal/CustomModal';

import cls from './ModalFiles.module.css';

interface IPopupProps {
    onHideModal: () => void;
    isShow: boolean;
    error: 'format' | 'size';
}

const textError = {
    format: i18next.t('Files.Popup.return.textError.format'),
    size: i18next.t('Files.Popup.return.textError.size'),
};

export const Popup = ({ onHideModal, isShow, error }: IPopupProps) => {
    const { t } = useTranslation();
    const handleKeyDown = useCallback(
        (event: KeyboardEvent) => {
            if (event.key === 'Escape' || event.key === 'Enter') {
                onHideModal();
            }
        },
        [onHideModal]
    );

    useEffect(() => {
        if (isShow) {
            document.addEventListener('keydown', handleKeyDown);
        }
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [isShow, onHideModal, handleKeyDown]);

    return (
        <>
            <CustomModal.Body width="476px" classes={cls.textAlignCenter}>
                {textError[error]}
            </CustomModal.Body>
            <CustomModal.Footer classes={cls.textAlignCenter}>
                <UiButton
                    onClick={onHideModal}
                    btnColor="secondary"
                    btnText={t('Files.Popup.return.ModalFooter')}
                />
            </CustomModal.Footer>
        </>
    );
};
